export const NEED_AUTHORIZATION_FOR_CONTINUE = 'NEED_AUTHORIZATION_FOR_CONTINUE'
export const GO_TO_PACKAGE_PAGE = 'GO_TO_PACKAGE_PAGE'
export const TO_PACKAGE_PAGE = 'TO_PACKAGE_PAGE'
export const TO_MAIN_PAGE = 'TO_MAIN_PAGE'
export const TO_LOAD_PAGE = 'TO_LOAD_PAGE'
export const TO_PLAY_PAGE = 'TO_PLAY_PAGE'
export const TO_GAME_FINISHED_PAGE = 'TO_GAME_FINISHED_PAGE'
export const TO_PACKAGE_FINISHED_PAGE = 'TO_PACKAGE_FINISHED_PAGE'

export const LOGIN_EVENT = 'LOGIN_EVENT'
export const SING_OUT_EVENT = 'SING_OUT_EVENT'
export const FINISH_PACKAGE_EVENT = 'FINISH_PACKAGE_EVENT'
export const NEXT_LEVEL_EVENT = 'NEXT_LEVEL_EVENT'

export const INIT_GAME = 'INIT_GAME'
export const GET_LEVEL_STATISTIC = 'GET_LEVEL_STATISTIC'
export const ROUTING = 'ROUTING'



// WEBPACK FOOTER //
// ./src/core/app/constants.js